import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type';
import { fetchApi } from '@/config/axiosSetting';
import {
  WalletPeriodUnsettledQueryParamsType,
  WalletPeriodUnsettledQueryResponseType,
} from './walletPeriodUnsettledQuery.type';

export const walletPeriodUnsettledFunction = ({
  year,
  month,
  page,
}: WalletPeriodUnsettledQueryParamsType): Promise<
  PaginationResponseType<WalletPeriodUnsettledQueryResponseType[]>
> => {
  return fetchApi.get(`financial/periods/${year}/${month}/unsettled/`, {
    params: { page },
  });
};
